import React from 'react';
import PropTypes from 'prop-types'

const FormDropdownUserOnline = (props) => {
    return (
        <div>
            <select 
                name={props.name} 
                className="form-control" 
                onChange={props.onChange} 
                value={props.value || ''}
                disabled={props.disabled || false}
            >
                <option value="">{props.placeholder || "- Pilih User Level :"}</option>
                {
                    props.items.map(item => {
                        return (
                            <option 
                                key={item.key} 
                                value={item.key}
                            >
                                {item.value}
                            </option>                
                        )
                    })
                }
            </select>
        </div>
    );
};

FormDropdownUserOnline.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    value: PropTypes.string,
}

export default FormDropdownUserOnline;


// WEBPACK FOOTER //
// ./src/components/FormDropdownUserOnline.js